import { LegalEntityBranchData } from 'chaika-frontend-types/frontend-cms';
import { OptionType } from '@components/Select';
import { getLegalEntityBranchStatusTranslation } from '@utils/enumTranslation';

export enum LegalEntityBranchStatus {
    Active = 'active',
    Archive = 'archive',
    Planned = 'planned',
}

export interface LegalEntityBranchDataWithEndData extends LegalEntityBranchData {
    end?: string;
    status: LegalEntityBranchStatus;
}

export const getLegalEntityBranchStatusOptions = (): OptionType<string>[] => [
    {
        value: LegalEntityBranchStatus.Active,
        label: getLegalEntityBranchStatusTranslation(LegalEntityBranchStatus.Active),
    },
    {
        value: LegalEntityBranchStatus.Archive,
        label: getLegalEntityBranchStatusTranslation(LegalEntityBranchStatus.Archive),
    },
    {
        value: LegalEntityBranchStatus.Planned,
        label: getLegalEntityBranchStatusTranslation(LegalEntityBranchStatus.Planned),
    },
];
